import { all, takeEvery, takeLatest } from 'redux-saga/effects'

import { DashboardActions, InternalMembersActions } from '../../actions'
import { cancelInvitation } from './cancelInvitation'
import { changeRole } from './changeRole'
import { fetchList } from './fetchList'
import { invite } from './invite'
import { leaveTeam } from './leaveTeam'
import { remove } from './remove'
import { suspend } from './suspend'
import { unsuspend } from './unsuspend'

export function* membersSaga() {
  yield all([
    takeEvery(DashboardActions.members.invite, invite),
    takeEvery(DashboardActions.members.cancelInvitation, cancelInvitation),
    takeEvery(DashboardActions.members.suspend, suspend),
    takeEvery(DashboardActions.members.unsuspend, unsuspend),
    takeEvery(DashboardActions.members.changeRole, changeRole),
    takeEvery(DashboardActions.members.delete, remove),
    takeEvery(DashboardActions.members.leaveTeam, leaveTeam),
    takeLatest(InternalMembersActions.fetchList, fetchList),
  ])
}
